import { render } from "./TourCard.vue?vue&type=template&id=3df99a71&scoped=true"
import script from "./TourCard.vue?vue&type=script&lang=js"
export * from "./TourCard.vue?vue&type=script&lang=js"

import "./TourCard.vue?vue&type=style&index=0&id=3df99a71&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df99a71"]])

export default __exports__